import React, { useImperativeHandle, useMemo } from 'react';
import type { RefObject } from 'react';

import type { Toast } from 'primereact/toast';
import type { selectedDate } from 'types/interfaces';

import type { TreeNode } from '../../types/interfaces';
import TaskEmployeeDistributionCard from '../tasks/taskEmployeeDistribution';

export interface UnassignedTasksDialogProps {
  visible: boolean;
  departmentId: number | null;
  dateFilter: selectedDate;
  toastRef: RefObject<Toast | null>;
  onClose: () => void;
  onAfterAssign?: () => void | Promise<void>;
}

export interface UnassignedTasksDialogRef {
  handleCancel: () => void;
}

const UnassignedTasksDialog = React.forwardRef<
  UnassignedTasksDialogRef,
  UnassignedTasksDialogProps
>(({ visible, departmentId, dateFilter, toastRef, onClose, onAfterAssign }, ref) => {
  useImperativeHandle(ref, () => ({
    handleCancel: onClose
  }), [onClose]);

  const selectedDepartmentsFilter = useMemo<TreeNode[]>(
    () =>
      departmentId
        ? [
            {
              key: String(departmentId),
              label: String(departmentId)
            }
          ]
        : [],
    [departmentId]
  );

  // TODO: Remove this calendarAssignments variant once the calendar dialog can use the distribution component without UI exceptions.
  return (
    <TaskEmployeeDistributionCard
      variant="calendarAssignments"
      visible={visible}
      selectedDepartmentsFilter={selectedDepartmentsFilter}
      treeDropDownValue={selectedDepartmentsFilter}
      isDepartmentsLoaded
      toastRef={toastRef}
      defaultDateFilter={dateFilter}
      onClose={onClose}
      onAfterAssign={onAfterAssign}
    />
  );
});

UnassignedTasksDialog.displayName = 'UnassignedTasksDialog';

export default UnassignedTasksDialog;
